module["exports"] = [
  "###-###-####",
  "(###) ###-####",
  "1-###-###-####",
  "###.###.####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/cell_phone/formats.js
 ** module id = 336
 ** module chunks = 0
 **/